import { recipe } from "@vanilla-extract/recipes";
import tokens from "../../tokens";

const button = recipe({
  base: {
    color: "currentcolor",

    ":focus": {
      border: `1px solid ${tokens.color.neutral.white}`,
      borderRadius: tokens.radius.minuscule,
    },
  },

  variants: {
    theme: {
      light: {
        ":hover": {
          color: tokens.color.full.gray800,
        },
      },
      purple: {
        color: tokens.color.full.gray500,
        ":hover": {
          color: tokens.color.core.primary,
        },
      },
    },
  },
});

const styles = {
  button,
};

export default styles;
